"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventStream = void 0;
const vscode = require("vscode");
class EventStream {
    constructor() {
        this.subscribeEmitter = new vscode.EventEmitter();
    }
    post(event) {
        this.subscribeEmitter.fire(event);
    }
    get subscribe() { return this.subscribeEmitter.event; }
}
exports.EventStream = EventStream;
//# sourceMappingURL=EventStream.js.map